import { Col, Form, Row, Segmented } from "antd";
import { useCurrencies } from "apps/Common/Currency/ServerSideStates";
import { FC,  useEffect,  useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";

const Pricing:FC<{segmentValue:number,setSegmentValue:any}> = ({segmentValue,setSegmentValue}) => {
  
  const { filter } = useSelector((state: RootState) => state.realState);
  const currencies = useCurrencies();


useEffect(()=>{
  if(Object.entries(filter).length <= 9)
    {
      setSegmentValue(1)
    }
    else  {
      setSegmentValue(filter?.CurrencyId||1)
    }
},[filter])



  return (

     
         
            <Segmented
              options={
                currencies?.data?.data
                  ? currencies.data.data.map((item: any) => ({
                      label: item.name,
                      value: item.id,
                    }))
                  : []
              }
              value={segmentValue}
              onChange={(value:number)=>{setSegmentValue(value)}}
            />
         
        
 
  );
};

export default Pricing;
